/**
 * @generated SignedSource<<cff49712e264f80a1d82b5df639ba25e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoFocusScreenListHeader_widgetTodoOverview$data = {
  readonly category: {
    readonly title: string;
  } | null;
  readonly teams: ReadonlyArray<{
    readonly name: string;
  }>;
  readonly " $fragmentType": "TodoFocusScreenListHeader_widgetTodoOverview";
};
export type TodoFocusScreenListHeader_widgetTodoOverview$key = {
  readonly " $data"?: TodoFocusScreenListHeader_widgetTodoOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoFocusScreenListHeader_widgetTodoOverview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoFocusScreenListHeader_widgetTodoOverview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};

(node as any).hash = "42c1561678654248ba6b30ff652c9a55";

export default node;
